import { Injectable } from '@angular/core';
import { PrincipalConfiguration } from '../../model';
import { Occ } from '../../occ/occ-models';
import { Converter } from '../../util';

@Injectable({ providedIn: 'root' })
export class PrincipalConfigurationNormalizer implements Converter<Occ.PrincipalConfiguration, PrincipalConfiguration> {
  convert(source: Occ.PrincipalConfiguration, target?: PrincipalConfiguration): PrincipalConfiguration {
    if (source) {
      let value: string | number | boolean;
      switch (source.type) {
        case 'BOOL':
          value = source.booleanValue;
          break;
        case 'NUMBER':
          value = source.intValue;
          break;
        case 'STRING':
        default:
          const { stringValue } = source;
          value = ['NONE', 'EMPTY'].includes(stringValue) ? null : stringValue;
      }
      target = {
        clientDisplayName: source.clientDisplayName,
        code: source.code,
        value: value,
        booleanValue: source.booleanValue,
      };
    }

    return target;
  }
}
